export default "/images/logo_login.png?c05fcbe54317f2cfc364da67922c1211";